
export const enumUtil = {
    enumtoaster: {
        success: 'success',
        info: 'info',
        error: 'error',
        warning: 'warning',
        basic: 'basic',
        dark: 'dark',
    },
    enumValidationType: {
        Required: 'requried',
        NullCheck: 'nullcheck',
        Length: 'length',
        Lengths: 'Lengths',
        StartEndDate: 'StartEndDate',
        Password: 'Password',
        Website: 'Website',
        Digit: 'Digit',
        Alphabet: 'Alphabet',
    },

    enumAPITableName: {
        GroupNote: 'GroupNote',
        AIFormMappings: 'AIFormMappings',
        CreateBulkClaimByEncounter: 'CREATEBULKCLAIMBYENCOUNTER',
        STAFFGROUP: 'STAFFGROUP',
        AIToolRequests: 'AIToolRequests',
        AIPromptDefinitions: 'AIPromptDefinitions',
        AllergyName: 'AllergyName',
        PatientIntakeCreditCard: 'PatientIntakeCreditCard',
        ReleaseOfInformationForm: 'ReleaseOfInformationForm',
        PATIENTACCOUNTDETAILS: 'PATIENTACCOUNTDETAILS',
        BillingDocumentApplied: 'BillingDocumentApplied',
        PatientInsuranceTemplateData: 'PatientInsuranceTemplateData',
        PATIENTAPPOINTMENTPROCEDURECODE: "PATIENTAPPOINTMENTPROCEDURECODE",
        AppointmentTypeProcedureCode: 'AppointmentTypeProcedureCode',
        PsychotherapyNote: "PsychotherapyNote",
        ShareEHRForm: "ShareEHRForm",
        EncounterDropDown: "EncounterDropDown",
        TherapyNote: "TherapyNote",
        PatientIntakeTemplateData: 'PatientIntakeTemplateData',
        NoteTypeSetting: 'NoteTypeSetting',
        NoteType: 'NoteType',
        ExcelWriteOffFiles: 'ExcelWriteOffFiles',
        ApplyFollowup: 'ApplyFollowup',
        PrintStatementsLogs: 'PrintStatementsLogs',
        StateCountyCity: 'StateCountyCity',
        ItemisedSummary: 'ItemisedSummary',
        SignEncounterInBulk: "SignEncounterInBulk",
        PatientPortal: 'PatientPortal',
        UserAudit: 'UserAudit',
        FILLDROPDOWNPAYMENTS: 'FILLDROPDOWNPAYMENTS',
        APPOINTMENTREMINDER: 'APPOINTMENTREMINDER',
        ProvAdjustmentReport: 'ProvAdjustmentReport',
        RECONCILATIONCOLLECTION: 'RECONCILATIONCOLLECTION',
        COGNITIVESTATUS: 'COGNITIVESTATUS',
        FUNCTIONALSTATUS: 'FUNCTIONALSTATUS',
        BulkEligibility: 'BulkEligibility',
        SubmissionRule: 'SubmissionRule',
        OtherNote: "OtherNote",
        GIRPNote: "GIRPNote",
        BIRPNote: "BIRPNote",
        DAPPNote: "DAPPNote",
        DAPNote: "DAPNote",
        EncounterProblem: "EncounterProblem",
        AuditPracticesSetting: 'AuditPracticesSetting',
        PatientTimeLine: 'PatientTimeLine',
        PARTIALLYDENIED: 'PARTIALLYDENIED',
        MISSINGACKNOWLEDGMENTS: 'MISSINGACKNOWLEDGMENTS',
        LinkEraChecks: 'LinkEraChecks',
        PatientReport: 'PatientReport',
        ERAVISITPAYMENT: 'ERAVISITPAYMENT',
        BILLINGITEMBLINKER: 'BILLINGITEMBLINKER',
        RECENTCODESERCH: "RECENTCODESERCH",
        Encounter: "Encounter",
        CHHISTORY: 'CHHISTORY',
        SUBMISSIONJOBLOGS: 'SUBMISSIONJOBLOGS',
        SaveEraPayment: "SaveEraPayment",
        ApplySendtoRCM: 'ApplySendtoRCM',
        GenderIdentity: "GenderIdentity",
        SexualOrientation: "SexualOrientation",
        PAYMENTSDATANEW: "PAYMENTSDATANEW",
        HealthConcern: "PatientHealthConcern",
        PatientIntakeForm: "PatientIntakeForm",
        BILLINGSTATUS: "BILLINGSTATUS",
        APPLYDELETEWRITEOFF: "APPLYDELETEWRITEOFF",
        EHRTemplate: "EHRTemplate",
        MANUALUNPOST: "MANUALUNPOST",
        ERAUNPOST: "ERAUNPOST",
        DeleteCheck: "DeleteCheck",
        PatientProblemList: "PatientProblemList",
        PatientGoal: "PatientGoal",
        PatientHistory: "PatientHistory",
        PatientRiskScore: "PatientRiskScore",
        PatientImplantableDevice: 'PATIENTIMPLANTABLEDEVICE',
        PatientAllergy: "PatientAllergy",
        ERAPaymentsPDF: "ERAPaymentsPDF",
        ManualPaymentsPDF: "ManualPaymentsPDF",
        AppointmentForClaim: "AppointmentForClaim",
        CountyMasterList: 'CountyMasterList',
        ProgramType: "ProgramType",
        FeeSetupCounty: "FeeSetupCounty",
        PracticeFeeSetupSchedule: 'PracticeFeeSetupSchedule',
        ClaimValidation: "ClaimValidation",
        UpdateClaim: "UpdateClaim",
        DeleteClaimReport: "DeleteClaimReport",
        ClaimFollowUp: "ClaimFollowUp",
        EDI_835_HEADER: 'EDI_835_HEADER',
        BillingItem: 'BillingItem',
        ClaimSetting: 'ClaimSetting',
        PATIENT: 'PATIENT',
        Discipline: 'Discipline',
        General: 'General',
        CareGiver: 'CareGiver',
        PatientAdmissionStatus: 'PatientAdmissionStatus',
        CoOrdinator: "CoOrdinator",
        Marketer: "Marketer",
        WriteOffReport: 'WriteOffReport',
        OverPayment: 'OverPayment',
        CollectionDetail: 'CollectionDetail',
        SubmittedClaimsReport: 'SubmittedClaimsReport',
        PatientAgingDetail: 'PatientAgingDetail',
        PatientAgingSummary: 'PatientAgingSummary',
        AgingDetail: 'AgingDetail',
        AgingSummary: 'AgingSummary',
        BillingBatches: 'BillingBatches',
        TemplatesReport: 'TemplatesReport',
        FilesReport: 'FilesReport',
        Dashboard: 'DASHBOARD',
        DashboardBillingPerformance: "DashboardBillingPerformance",
        BILLINGDOCUMENTNOTES: 'BILLINGDOCUMENTNOTES',
        CollectCopay: 'CollectCopay',
        SubmissionNotes: "SubmissionNotes",
        PatientAppointment: 'PatientAppointment',
        PatientPayments: 'PatientPayments',
        Practice: 'practice',
        SwitchPractice: 'Practice',
        Provider: 'Provider',
        RefProvider: 'RefProvider',
        Location: 'Location',
        BillingProv: 'BillingProv',
        Insurance: 'Insurance',
        InsuranceDocument: "InsuranceDocument",
        Diagnosis: "Diagnosis",
        Procedure: 'Procedure',
        Modifier: 'Modifier',
        RevenueCode: 'RevenueCode',
        Patient: 'Patient',
        POS: 'POS',
        SAVEPAYMENTS: 'SAVEPAYMENTS',
        PaymentsData: 'PaymentsData',
        Adjustmentcodes: 'AdjustmentCode',
        Remarkcodes: 'RemarkCode',
        DenialGroup: 'DenialGroup',
        WriteOffGroup: 'WriteOffGroup',
        InsuranceType: 'InsuranceType',
        ClaimStatusCategoryCode: 'ClaimStatusCategoryCode',
        ClaimStatusCode: 'ClaimStatusCode',
        PatientInsurance: 'PatientInsurance',
        InsurranceCategory: 'insurancecategory',
        PatientGuarantor: 'PatientGuarantor',
        PatientEmergencyContact: 'PatientEmergencyContact',
        PatientFamilyMember: 'PatientFamilyMember',
        SubmitterReceiver: 'SubmitterReceiver',
        BillingProvider: 'BillingProvider',
        Claim: 'Claim',
        ServiceLine: 'ServiceLine',
        ClaimInsurance: 'ClaimInsurance',
        ClaimDiagnosis: 'ClaimDiagnosis',
        Payment: 'Payment',
        PAYMENTSUMMARY: 'PAYMENTSUMMARY',
        BillingBatch: 'BillingBatch',
        GlobalSearch: 'GlobalSearch',
        DENIEDVISITS: 'DENIEDVISITS',
        Generate276: 'Generate276',
        HEADER_PAYMENT: 'EOB_835_HEADER',
        VISIT_PAYMENT: 'EOB_835_VISIT_PAYMENT',
        SERVICE_LINE_PAYMENT: 'EOB_835_SERVICE_LINE_PAYMENT',
        RemarkCode: 'RemarkCode',
        SavePayments: 'SavePayments',
        ElectronicSubmission: "ElectronicSubmission",
        PaperSubmission: 'PaperSubmission',
        DownloadHistory: 'DownloadHistory',
        Taxonomy: 'Taxonomy',
        EDIClaimBatch: "EDIClaimBatch",
        PatientDMGData: 'PatientDMGData',
        Aging: 'Aging',
        PaymentReconcilaition: "PAYMENTRECONCILIATION",
        PatientAuthorization: "PatientAuthorization",
        User: 'User',
        Exceptions: 'Exceptions',
        CheckDetails: 'CheckDetails',
        DownloadFile: 'DownloadFile',
        TransportClaim: 'TransportClaim',
        PatientDocument: 'PatientDocument',
        DocumentType: 'DocumentType',
        BILLINGDOCUMENTTYPE: "BILLINGDOCUMENTTYPE",
        PatientEligibility: 'PatientEligibility',
        EligibilityLog: 'EligibilityLog',
        ClaimStatus: 'ClaimStatus',
        ClaimStatusLog: 'ClaimStatusLog',
        PatientStatus: 'PatientStatus',
        AdmissionType: 'AdmissionType',
        AdmissionSource: 'AdmissionSource',
        VisitType: "VisitType",
        InstitutionalHealthCodes: 'InstitutionalHealthCodes',
        PatientNotes: 'PatientNotes',
        ClaimNotes: 'ClaimNotes',
        PaymentsNotes: 'PaymentsNotes',
        ConditionCode: 'ConditionCode',
        ExternalInjuryCode: 'ExternalInjuryCode',
        AdmissionSourceCode: 'AdmissionSourceCode',
        OccurrenceCode: 'OccurrenceCode',
        OccurrenceSpanCode: 'OccurrenceSpanCode',
        PatientStatusCode: 'PatientStatusCode',
        ValueCode: 'ValueCode',
        TreatmentCode: 'TreatmentCode',
        DRGCode: 'DRGCode',
        ClaimStatusData: 'ClaimStatusData',
        EligibilityData: 'EligibilityData',
        ServiceLineSubmissionHistory: 'ServiceLineSubmissionHistory',
        ProviderSchedule: "ProviderSchedule",
        Templates: "Templates",
        GenerateHCFA: 'GenerateHCFA',
        Generate270: 'Generate270',
        StatementSetting: "StatementSetting",
        ProcedureMacro: "ProcedureMacro",
        ProcedureMacroServiceLine: "ProcedureMacroServiceLine",
        CLAIMSTATUSLOG: 'CLAIMSTATUSLOG',
        ClaimResponses: 'ClaimResponses',
        ClaimRejection: 'ClaimRejection',
        MARKASSUBMITTED: 'MARKASSUBMITTED',
        RESUBMIT: 'RESUBMIT',
        VisitSummary: 'VisitSummary',
        ChangeStatus: 'ChangeStatus',
        TransferToPatient: 'TransferToPatient',
        WriteOff: 'WriteOff',
        ApplyWriteOff: 'ApplyWriteOff',
        Discount: 'Discount',
        ApplyDiscount: 'ApplyDiscount',
        Files: "Files",
        GETPAYMENTLEDGERS: 'GETPAYMENTLEDGERS',
        PostERA: 'PostEra',
        PostManual: 'POSTMANUAL',
        COLLECTIONSUMMARY: 'COLLECTIONSUMMARY',
        COLLECTIONDETAIL: 'COLLECTIONDETAIL',
        ClaimActivity: 'ClaimActivity',
        RECONCILIATIONSUMMARY: 'RECONCILIATIONSUMMARY',
        Task: "Task",
        Alert: "Alert",
        PATIENTVALIDATION: 'PATIENTVALIDATION',
        PATIENTINSURANCEVALIDATION: 'PATIENTINSURANCEVALIDATION',
        TaskAttachments: 'TaskAttachments',
        ImportPatient: 'ImportPatient',
        AppointmentType: 'AppointmentType',
        PatientSummary: 'PatientSummary',
        Scheduler: "Scheduler",
        AppointmentStatus: 'AppointmentStatus',
        GETPRACTICEDENIEDCODE: 'GETPRACTICEDENIEDCODE',
        PRINTSTATEMENTS: 'PRINTSTATEMENTS',
        PAYMENTRECONCILIATION: 'PAYMENTRECONCILIATION',
        COLLECTPATIENTPAYMENTS: 'COLLECTPATIENTPAYMENTS',
        EDI_835_SERVICE_LINE_PAYMENT: 'EDI_835_SERVICE_LINE_PAYMENT',
        SAVELOCATIONSCHEDULE: 'SAVELOCATIONSCHEDULE',
        PATIENTSTATEMENTSETUP: 'PATIENTSTATEMENTSETUP',
        TASKCOMMENTS: 'TASKCOMMENTS',
        TICKETCOMMENTS: 'TICKETCOMMENTS',
        BILLINGDOCUMENT: 'BILLINGDOCUMENT',
        BILLINGDOCUMENTAPPLIED: 'BILLINGDOCUMENTAPPLIED',
        MASTERLISTPOS: 'MASTERLISTPOS',
        DESIGNATION: 'DESIGNATION',
        DEPARTMENT: 'DEPARTMENT',
        LOCATIONSCHEDULE: 'LOCATIONSCHEDULE',
        FindPatientAuthorization: "FindPatientAuthorization",
        SupportTicket: 'SupportTicket',
        SUPPORTTICKETATTACHMENTS: 'SUPPORTTICKETATTACHMENTS',
        SUPPORTTICKETCOMMENTS: 'SUPPORTTICKETCOMMENTS',
        PATIENTAGING: 'PATIENTAGING',
        WRITEOFFREPORT: 'WRITEOFFREPORT',
        OVERPAYMENTREPORT: 'OVERPAYMENTREPORT',
        SUBMITTEDREPORT: 'SUBMITTEDREPORT',
        PATIENTAUTHORIZATIONREPORT: "PATIENTAUTHORIZATIONREPORT",
        DiscountReport: 'DiscountReport',
        GridSettings: 'GridSettings',
        USERPRACTICES: 'USERPRACTICES',
        COLLECTCOPAY: "COLLECTCOPAY",
        Roles: "Roles",
        ApplyChangeStatus: 'ApplyChangeStatus',
        ApplyMarkAsSubmitted: 'ApplyMarkAsSubmitted',
        APPLYTRANSFERTOPATIENT: 'APPLYTRANSFERTOPATIENT',
        APPLYTRANSFERTOINSURANCE: 'APPLYTRANSFERTOINSURANCE',
        APPLYDELETECLAIM: 'APPLYDELETECLAIM',
        InsuranceMapping: 'InsuranceMapping',
        ApplyReSubmit: 'ApplyReSubmit',
        BillingDocumentApplied: 'BillingDocumentApplied',
        Caregiver: 'CareGiver',
        CaregiverDocument: 'CareGiverDocument',
        EmployementStatus: 'EmployementStatus',
        SaveAgencyClaim: 'SaveAgencyClaim',
        ClaimAgencyGridView: 'ClaimAgencyGridView',
        VISITS: "VISITS",
        AgencyClaim: 'AgencyClaim',
        GetPracticesSetting: 'GetPracticesSetting',
        FindAgencyPatientAuthorization: 'FindAgencyPatientAuthorization',
        AgencyPatient: 'AgencyPatient',
        FindPatientAuthorizationByClaim: 'FindPatientAuthorizationByClaim',
        AgencyProviderFeeSchedule: 'AgencyProviderFeeSchedule',
        WEEKSUBMISSIONREPORT: 'WEEKSUBMISSIONREPORT',
        NORESPONSEVISIT: 'NORESPONSEVISIT',
        VISITSREPORT: 'VISITSREPORT',
        ExternalPaymentReport: 'ExternalPaymentReport',
        NoResponseVisit: 'NoResponseVisit',
        BillingEntity: 'BillingEntity',
        GENERATEUB04: 'GENERATEUB04',
        ApplyCancelReSubmit: "ApplyCancelReSubmit",
        TIMELYFILLINGREPORT: 'TIMELYFILLINGREPORT',
        MasterWeekSchedule: 'MASTERWEEKSCHEDULE',
        CREATEBULKCLAIM: 'CREATEBULKCLAIM',
        PatientCalendar: 'PATIENTCALENDAR',
        APPLYCOPYCLAIM: "APPLYCOPYCLAIM",
        Monitoring: 'Monitoring',
        ClaimDocument: 'ClaimDocument',
        PATIENTCAREGIVERS: 'PATIENTCAREGIVERS',
        AUTODOWNLOADJOBLOGS: 'AUTODOWNLOADJOBLOGS',
        ClaimAttachmentHistory: "ClaimAttachmentHistory",
        EHRTEMPLATE: 'EHRTEMPLATE',
        AppointmentSettings: 'AppointmentSettings',
        InsuranceByMD: 'InsuranceByMD',
        MasterListRevenueCode: 'MasterListRevenueCode',
        MasterListModifier: 'MasterListModifier',
        SubmitterIntegration: "SubmitterIntegration",
        RestoreDeletedClaim: 'RestoreDeletedClaim',
        CLAIMINFO: 'CLAIMINFO',
        ChargeListReport: 'ChargeListReport',
        PATIENTATTENDANCE: 'PATIENTATTENDANCE',
        RefreshClaimStatus: 'RefreshClaimStatus',
        GetUserSalt: 'GetUserSalt',
        Shifts: 'Shifts',
        CREATEBULKCLAIMBYATTENDANCE: 'CREATEBULKCLAIMBYATTENDANCE',
        POSTINGJOBLOGS: 'POSTINGJOBLOGS',
        INSURANCEADDRESSDROPDOWN: 'INSURANCEADDRESSDROPDOWN',
        LAWYER: 'LAWYER',
        EMPLOYER: 'EMPLOYER',
        Staffs: 'Staffs',
        ICDPCS: 'ICDPCS',
        ApplySendtoRCM: 'ApplySendtoRCM',
        RecurringAppointment: 'RecurringAppointment',
        PatientIntakeForm: 'PatientIntakeForm',
        Messages: 'Messages',
        ERAAudit: 'ERAAudit',
        PatientAdvanceDirectives: 'PatientAdvanceDirectives',
        Vital: 'Vital',
        PatientMessage: 'PatientMessage',
        PatientMessageDetail: 'PatientMessageDetail',
        ClaimRuleRef: 'ClaimRuleRef',
        PracticesSetting: 'PracticesSetting',
        INSTANTGENERATE270: 'INSTANTGENERATE270',
        InstantEligibility: 'InstantEligibility',
        MassageNote: 'MassageNote',
        PhysicalNote: 'PhysicalNote',
        CustomNote: "CustomNote",
        FormPackets: 'FormPackets'
    },
    controller: {
        DownloadEncounterFiles: 'DownloadEncounterFiles',
        AiConfigurations: 'AiConfigurations',
        AITool: 'AITool',
        GenerateNote: 'GenerateNote',
        AINoteWorkflows: "AINoteWorkflows",
        AINoteWorkflows: 'AINoteWorkflows',
        AINoteTaker: "AINoteTaker",
        Propelrpay: 'Propelrpay',
        PatientPay: 'PatientPay',
        PatientPortalLogin: 'PatientPortalLogin',
        PatientIntakePortal: 'PatientIntakePortal',
        Visit: 'Visit',
        ClaimRules: 'ClaimRules',
        Dashboard: "Dashboard",
        General: 'General',
        PAYMENT: 'PAYMENT',
        PATIENT: 'PATIENT',
        Patient: 'Patient',
        CareGiver: 'CareGiver',
        Claim: 'Claim',
        Payment: 'Payment',
        ElectronicSubmission: "ElectronicSubmission",
        PaperSubmission: 'PaperSubmission',
        DownloadHistory: 'DownloadHistory',
        Wasabi: 'Wasabi',
        AccountReceiveable: 'AccountReceiveable',
        Download: 'Download',
        Wasabi_Download: 'wasabi/DownloadFile',
        Audit: 'Audit',
        EDI: 'EDI',
        Submission: 'Submission',
        Report: 'Report',
        Login: 'Login',
        Tenant: 'api/tenant',
        Eligibility: 'Eligibility',
        ClaimStatus: 'ClaimStatus',
        ClaimStatusData: 'ClaimStatusData',
        Institutional: 'Institutional',
        DataImport: 'DataImport',
        Reports: "Reports",
        ExcelExport: 'ExcelExport',
        PatientPayment: 'PatientPayment',
        MasterList: 'MasterList',
        Messages: 'Messages',
        MenuOption: 'MenuOption',
        PracticesSetting: 'PracticesSetting',
        HHAX: 'HHAX',
        AgencyClaim: 'AgencyClaim',
        AgencyPatient: 'AgencyPatient',
        ProviderFeeSchedule: 'ProviderFeeSchedule',
        ClaimOptions: 'ClaimOptions',
        InsuranceDocument: 'InsuranceDocument',
        AuthScheduler: 'AuthScheduler',
        Integration: 'Integration',
        Monitoring: "Monitoring",
        EHRTemplate: "EHRTemplate",
        PatientEncounter: "PatientEncounter",
        OCRPDF: "OCRPDF",
        OCR: "OCR",
        PracticesSetting: 'PracticesSetting',
        InovicePayment: 'InovicePayment',
        PatientMessage: 'PatientMessage',
        ClaimOptions: 'ClaimOptions',
        FormPacket: 'FormPacket',
    },

}